document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('a[href]');
  const currentDomain = window.location.hostname;
  links.forEach(link => {
    const href = link.getAttribute('href');
    if (!href) return;
    // Skip anchors, mailto, tel, javascript
    if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
    // Skip checkout and cart links
    if (href.includes('/checkout') || href.includes('/cart')) return;
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
});

